import log from "loglevel";
log.enableAll();

const SETTINGS = {
  THE_ANSWER: 42,
  MARKERS: {
    TYPES: ["🏴", "🌳", "🏛", "🌻", "⭐️", "🚧", "🚙"],
  },
  TERRAIN: {
    SCALE: 1000,
  },
  ANIMATION: {
    DEFAULT: { mass: 2, tension: 500, friction: 50, velocity: 20 },
  },
  KEYBOARD: {
    ALT_KEY: "Shift",
  },
};

const overrides = {
  // DO NOT EDIT
  // This is a placeholder for user settings saved locally that get merged into the main object
};

/*
 * Recursively merge properties of two objects
 */
function MergeRecursive(obj1, obj2) {
  for (var p in obj2) {
    try {
      // Property in destination object set; update its value.
      if (obj2[p].constructor == Object) {
        obj1[p] = MergeRecursive(obj1[p], obj2[p]);
      } else {
        obj1[p] = obj2[p];
      }
    } catch (e) {
      // Property in destination object not set; create it and set its value.
      obj1[p] = obj2[p];
    }
  }

  return obj1;
}

export default MergeRecursive(SETTINGS, overrides);

// Other additions

Math.clamp = (value) => Math.min(Math.max(value, 0), 1);

Date.prototype.isLeapYear = function () {
  var year = this.getFullYear();
  if ((year & 3) != 0) return false;
  return year % 100 != 0 || year % 400 == 0;
};

// Get Day of Year
Date.prototype.getDOY = function () {
  var dayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  var mn = this.getMonth();
  var dn = this.getDate();
  var dayOfYear = dayCount[mn] + dn;
  if (mn > 1 && this.isLeapYear()) dayOfYear++;
  return dayOfYear;
};
